export default "__VITE_ASSET__1DNvGyPv__"